/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScheduledTaskStatus } from './scheduledTaskStatus';

/**
 * One row inside ThreadDetail.scheduled_tasks / ChatDetail.scheduled_tasks.
 */
export interface ScheduledTask {
  task_id: string;
  scheduled_for_at: string;
  timezone: string;
  status: ScheduledTaskStatus;
}
